import { inject } from "fw";

import { OrganizationModuleService } from "service/organization-module";

@inject
export class ModulePopover {
  private router = null;

  constructor(private organizationModuleService: OrganizationModuleService) {}

  get isEnabled() {
    return this.organizationModuleService.isEnabled;
  }

  activate(router) {
    this.router = router;
  }
}
